import { render } from "./ButtonUp.vue?vue&type=template&id=6af114c4&scoped=true"
import script from "./ButtonUp.vue?vue&type=script&lang=js"
export * from "./ButtonUp.vue?vue&type=script&lang=js"

import "./ButtonUp.vue?vue&type=style&index=0&id=6af114c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af114c4"]])

export default __exports__